// ─────────────────────────────────────────────────────────────
// EDITABLE SERVICES DATA
// NOTE: The entries below are clearly-labelled SAMPLE placeholders.
// Replace with the salon's verified service menu, prices and
// durations when provided. price: null renders
// "Contact salon for current pricing".
// ─────────────────────────────────────────────────────────────

const img = (id, w = 900) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const serviceCategories = [
  "Hair",
  "Hair Colour",
  "Hair Treatments",
  "Beauty",
  "Grooming",
  "Styling",
  "Other",
];

// Homepage category showcase (design placeholders)
export const categoryShowcase = [
  {
    name: "Hair",
    description:
      "Cuts, care and finishing — shaped around your hair and your routine.",
    image: img("1519699047748-de8e457a634e"),
    alt: "Healthy textured hair styled at a salon in Banjara Hills",
  },
  {
    name: "Colour",
    description:
      "From subtle refreshes to complete transformations, coloured with care.",
    image: img("1492106087820-71f1a00d2b11"),
    alt: "Soft coloured waves after a salon colour service",
  },
  {
    name: "Beauty",
    description:
      "Beauty essentials and glow-care rituals in a calm salon setting.",
    image: img("1487412947147-5cebf100ffc2"),
    alt: "Professional makeup and beauty application",
  },
  {
    name: "Styling",
    description:
      "Blow-dries, occasion styling and finishing touches for every look.",
    image: img("1522337094846-8a818192de1f"),
    alt: "Hair being set in curlers during a styling session",
  },
];

// SAMPLE placeholder service entries — replace with the verified menu.
export const services = [
  {
    id: "haircut-finish",
    name: "Haircut & Finish",
    category: "Hair",
    description:
      "A considered cut tailored to your face shape, texture and lifestyle, finished with styling.",
    price: null,
    duration: null,
    image: img("1622287162716-f311baa1a2b8"),
    alt: "Stylist finishing a precision haircut",
    featured: true,
  },
  {
    id: "global-colour",
    name: "Global Colour",
    category: "Hair Colour",
    description:
      "All-over colour applied with care, from natural tones to bolder statements.",
    price: null,
    duration: null,
    image: img("1492106087820-71f1a00d2b11"),
    alt: "Finished all-over hair colour with soft waves",
    featured: true,
  },
  {
    id: "hair-spa",
    name: "Hair Spa Ritual",
    category: "Hair Treatments",
    description:
      "A relaxing treatment ritual designed to nourish hair and restore softness and shine.",
    price: null,
    duration: null,
    image: img("1519415510236-718bdfcd89c8"),
    alt: "Relaxing salon spa ritual with warm water",
    featured: false,
  },
  {
    id: "texture-care",
    name: "Texture & Curl Care",
    category: "Hair Treatments",
    description:
      "Care designed around your natural texture — hydration, definition and shape.",
    price: null,
    duration: null,
    image: img("1519699047748-de8e457a634e"),
    alt: "Natural curls cared for and defined",
    featured: false,
  },
  {
    id: "blow-dry",
    name: "Blow-Dry & Styling",
    category: "Styling",
    description:
      "A professional blow-dry and style — from effortless everyday to occasion-ready.",
    price: null,
    duration: null,
    image: img("1620331311520-246422fd82f9"),
    alt: "Professional hair dryer and styling tools",
    featured: true,
  },
  {
    id: "occasion-styling",
    name: "Occasion Styling",
    category: "Styling",
    description:
      "Styling for events and celebrations, planned around your outfit and occasion.",
    price: null,
    duration: null,
    image: img("1522337094846-8a818192de1f"),
    alt: "Hair being set for an occasion style",
    featured: false,
  },
  {
    id: "glow-care",
    name: "Clean-Up & Glow Care",
    category: "Beauty",
    description:
      "A refreshing beauty clean-up to revive and brighten, in a calm salon setting.",
    price: null,
    duration: null,
    image: img("1487412947147-5cebf100ffc2"),
    alt: "Beauty clean-up and glow care application",
    featured: false,
  },
  {
    id: "nail-care",
    name: "Nail Care",
    category: "Beauty",
    description:
      "Neat, polished nail care — shaping, care and a clean finish.",
    price: null,
    duration: null,
    image: img("1522337660859-02fbefca4702"),
    alt: "Nail care and polish application",
    featured: false,
  },
  {
    id: "mens-grooming",
    name: "Men's Cut & Grooming",
    category: "Grooming",
    description:
      "Sharp cuts, beard shaping and grooming essentials for a polished finish.",
    price: null,
    duration: null,
    image: img("1503951914875-452162b0f3f1"),
    alt: "Men's grooming and razor finish at the salon",
    featured: true,
  },
  {
    id: "beard-shave",
    name: "Beard & Shave Ritual",
    category: "Grooming",
    description:
      "A classic hot-towel style ritual — precise lines, clean finish, unhurried.",
    price: null,
    duration: null,
    image: img("1599351431202-1e0f0137899a"),
    alt: "Detailed beard and shave work in progress",
    featured: false,
  },
];

export const pricingNote = "Contact salon for current pricing";
export const servicesDisclaimer =
  "Sample menu shown for preview — please contact the salon for the current service list, availability and pricing.";
